import { Injectable } from '@angular/core';
import { PaymentInstallment } from '../entities/payment-installment';
import { BaseTableService } from './base-table.service';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '@mobileia/authentication';

@Injectable({
  providedIn: 'root'
})
export class PaymentInstallmentService extends BaseTableService<PaymentInstallment> {

  constructor(
    protected http: HttpClient,
    protected authService: AuthenticationService
  ) {
    super(http, authService);
    this.basePathUrl = 'admin/payment-installment';
  }
  
}
